import { is_function } from "./is_function"

export const is_iterator = obj => {
  if (obj) {
    return is_function(obj.next)
  }
  return false
}
